import React from 'react';

// COMPONENTS
import PageBanner from '../../components/general/PageBanner';
import AllUsersTable from './AllUsersTable';
import PendingProjects from './PendingProjects';
import ActiveProjects from './ActiveProjects';
import SuccessfulProjects from './SuccessfulProjects';
import FailedProjects from './FailedProjects';
import WaitingForApproval from './WaitingForApproval';
import useUser from '../../hooks/useUser';
import AppStats from './AppStats';
import TokensUSDPricing from './TokensUSDPricing';

function AdminPanel() {
    const { userInfo } = useUser();

    return (
        <>
            <PageBanner
                heading='Admin Panel'
                text='With great power comes great responsibility'
            ></PageBanner>
            <section className='pb-5 page-first-section'>
                <div className='container pb-5'>
                    <header className='mb-5'>
                        <h2 className='mb-0'>Hi {userInfo?.name}</h2>
                        <p className='text-muted'>Here're some stats about your app</p>
                    </header>

                    <div className='mb-3'>
                        <AppStats />
                    </div>

                    <div className='mb-3'>
                        <TokensUSDPricing />
                    </div>

                    <div className='mb-3'>
                        <WaitingForApproval />
                    </div>

                    <div className='mb-3'>
                        <AllUsersTable />
                    </div>

                    <div className='mb-3'>
                        <PendingProjects />
                    </div>

                    <div className='mb-3'>
                        <ActiveProjects />
                    </div>

                    <div className='mb-3'>
                        <SuccessfulProjects />
                    </div>

                    <div className='mb-3'>
                        <FailedProjects />
                    </div>
                </div>
            </section>
        </>
    );
}

export default AdminPanel;
